import { useEffect, useRef } from 'react';
import { useLocation } from 'wouter';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/_core/hooks/useAuth';
import { LoginPrompt } from '@/components/auth/AuthDialog';
import { openDashboardPath } from '@/contexts/AuthContext';
import { defaultPortalPath } from '@/utils/portalRouting';

/**
 * Bookmarks to /admin hop to the Laravel staff dashboard.
 */
export default function AdminDashboardHop() {
  const { user, loading, isAuthenticated } = useAuth();
  const [, navigate] = useLocation();
  const hopped = useRef(false);

  useEffect(() => {
    if (loading || hopped.current || !isAuthenticated || !user) return;
    if (user.role === 'admin') {
      hopped.current = true;
      void openDashboardPath('/');
      return;
    }
    hopped.current = true;
    navigate(defaultPortalPath(user), { replace: true });
  }, [loading, isAuthenticated, user, navigate]);

  if (loading || (isAuthenticated && user?.role === 'admin')) {
    return (
      <div className="min-h-screen bg-[#050d1a] flex items-center justify-center">
        <Loader2 className="h-8 w-8 text-[#29ffa9] animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-[#050d1a] text-white">
        <LoginPrompt message="Sign in to open the admin dashboard." />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050d1a] flex items-center justify-center">
      <Loader2 className="h-8 w-8 text-[#29ffa9] animate-spin" />
    </div>
  );
}
